import {
  degreeDaysRecord,
  larvalTrendRecord,
  phenologyRecord,
  trapCatchesRecord,
} from 'stores/selectedValueGroupsStore/insectValueGroupRecords'
import type { TValueGroup } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import { unitConverter } from 'utils/unitConverter/unitConverter'

// TODO: we'll be able to change this to the value-type definitions things in the future
export const valueGroupsToUnitConverterFunctionForRendering: Record<
  TValueGroup,
  (typeof unitConverter)[keyof typeof unitConverter] | undefined // better to put undefined than to make this whole thing a partial
> = {
  air_temperature: unitConverter.temperatureInCanopy,
  almond_bloom: unitConverter.almondBloom,
  almond_hull_split: undefined,
  alternaria: undefined,
  atmospheric_pressure: undefined,
  bee_hours: unitConverter.beeHours,
  cherry_powdery_mildew: unitConverter.cherryPowderyMildew,
  chill: unitConverter.chillCumulativeHoursBelow45FSEP, // feels weird, since this'll change, but we'll change to using value-type definitions in the future
  conditions: undefined,
  ...degreeDaysRecord(() => unitConverter.insectDegreeDaysCumulative),
  dew_point: unitConverter.dewPointInCanopy,
  equipment_status: undefined,
  evapotranspiration: unitConverter.evapotranspiration,
  fire_blight: undefined,
  fruit_growth: unitConverter.fruitGrowth,
  grape_powdery_mildew: unitConverter.grapePowderyMildew,
  plant_stress: unitConverter.plantWaterStress,
  humidity: unitConverter.humidityInCanopy,
  irrigation_activity_pressure: undefined,
  irrigation_activity_zones: undefined,
  irrigation_activity_flow_meters: undefined,
  ...larvalTrendRecord(() => undefined),
  leaf_wetness: unitConverter.leafWetnessHours,
  ndvi: undefined,
  precipitation: unitConverter.precipitation,
  soil: unitConverter.soilAwc,
  spray_conditions: undefined,
  ...trapCatchesRecord(() => undefined),
  ...phenologyRecord(() => undefined),
  wet_bulb: unitConverter.wetBulbInCanopy,
  wind: unitConverter.windSpeed,
  wind_machine: unitConverter.windMachineTemperature,
}
